import { useNavigate, Link, useSearchParams } from "react-router-dom";
import SEO from "../components/SEO";
import PhoneAuth from "../components/PhoneAuth";

export default function AuthPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect");
  const safeRedirect = redirect && redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : null;

  const goAfterAuth = (user) => {
    navigate(safeRedirect || (user?.role === "admin" ? "/admin" : "/account"));
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="auth-page">
      <SEO title="Sign In" description="Sign in to your Humaira Crafts account with your mobile number" />
      <h1 className="text-4xl tracking-tighter font-semibold text-center mb-3">Your Account</h1>
      <p className="text-sm text-muted-foreground text-center mb-10">One mobile number. All your orders, addresses and wishlist — on every device.</p>

      <PhoneAuth onSuccess={goAfterAuth} testidPrefix="auth" />

      <p className="text-xs text-muted-foreground text-center mt-8">
        Shopping first? <Link to="/checkout" className="text-gold underline" data-testid="guest-checkout-link">Go straight to checkout</Link> — we verify your mobile number there.
      </p>
    </div>
  );
}
